<template>
    <label :for="label">{{ label }}</label>
    <div class="p-inputgroup">
        <Calendar :showIcon="true" :disabled="true"/>
    </div>
</template>

<script>
export default {
    name: 'DateInput',
    props: {
        label: {
            type: String,
        },
    },
};
</script>
